var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLongitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 25.8332V23.4999C9.40287 23.2276 7.31746 22.2214 5.57718 20.4811C3.8369 18.7408 2.83065 16.6554 2.55843 14.2249H0.225098V11.8915H2.55843C2.83065 9.46098 3.8369 7.37556 5.57718 5.63529C7.31746 3.89501 9.40287 2.88876 11.8334 2.61654V0.283203H14.1668V2.61654C16.5973 2.88876 18.6827 3.89501 20.423 5.63529C22.1633 7.37556 23.1695 9.46098 23.4418 11.8915H25.7751V14.2249H23.4418C23.1695 16.6554 22.1633 18.7408 20.423 20.4811C18.6827 22.2214 16.5973 23.2276 14.1668 23.4999V25.8332H11.8334ZM13.0001 21.2249C15.2557 21.2249 17.1807 20.4276 18.7751 18.8332C20.3695 17.2388 21.1668 15.3138 21.1668 13.0582C21.1668 10.8026 20.3695 8.87765 18.7751 7.2832C17.1807 5.68876 15.2557 4.89154 13.0001 4.89154C10.7445 4.89154 8.81954 5.68876 7.2251 7.2832C5.63065 8.87765 4.83343 10.8026 4.83343 13.0582C4.83343 15.3138 5.63065 17.2388 7.2251 18.8332C8.81954 20.4276 10.7445 21.2249 13.0001 21.2249Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLongitude);
export default __webpack_public_path__ + "static/media/icon_longitude.82f8772fc303bc56c4b8a8fd2494356e.svg";
export { ForwardRef as ReactComponent };